<template>

    <Grid>

        <Column>

            <Paragraph class="breadcrumb">

                <template v-for="(path, index) of paths" :key="index">

                    <Anchor :route="path.route" class="breadcrumb__link text-pink-300 uppercase font-normal" :bold="false">

                        {{ path.text }}

                    </Anchor>

                    <span v-if="index !== paths.length - 1" class="text-black"> / </span>

                </template>

            </Paragraph>

        </Column>

    </Grid>

</template>

<script lang="ts">

    import { defineComponent, PropType } from 'vue'
    import Grid from './Grid/Grid.vue'
    import Column from './Grid/Column.vue'
    import Anchor from './Anchor.vue'
    import Paragraph from './Paragraph.vue'
    import { RouteLocation } from 'vue-router'

    interface PathInterface {
        route: RouteLocation | string,
        text: string
    }

    export default defineComponent({
        name: 'Breadcrumb',
        components: {
            Grid,
            Column,
            Anchor,
            Paragraph
        },
        props: {
            paths: { type: Array as PropType<PathInterface[]>, required: true }
        },
        setup(props) {

            return {
                data: props.paths.join(' / ').toUpperCase()
            }

        }
    })

</script>

<style lang="scss">

    @include component(breadcrumb) {

        @include part(link) {

            font-size: 12px;

        }

        span {

            font-size: 12px;

        }

    }

</style>
